// Decodes a JWT's payload without verifying its signature. Verification always happens
// server-side; this is only used to read display-only claims (e.g. email) out of a token
// the browser already holds, mirroring how the native login flow trusts the email the user
// just typed for display purposes.
export function decodeJwtPayload(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}
